import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { ParentInfoStoreState } from './parentInfoStoreTypes'

export const useParentInfoStore = create<ParentInfoStoreState>()(
  devtools(() => ({} as ParentInfoStoreState))
)
